// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__SqnNx","linksContainer":"Footer_linksContainer__vgSje"};